import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useTheme } from "@/components/ui/theme-provider";

interface NumberQuestionProps {
  value: string;
  onChange: (value: string) => void;
}

export const NumberQuestion = ({ value, onChange }: NumberQuestionProps) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  return (
    <div className="space-y-2">
      <Input
        type="number"
        min="1"
        max="5"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full ${isDarkMode ? 'bg-[#121a2e]' : 'bg-white'} border-green-500/30 text-foreground focus:border-green-500 focus:ring-green-500 text-base md:text-sm h-12 md:h-10`}
        inputMode="numeric"
        pattern="[0-9]*"
      />
    </div>
  );
};